import type { ReactNode } from 'react';
import { createContext, useContext, useMemo } from 'react';

import type { TransitionStatus } from 'react-transition-group';

interface Context {
  state: TransitionStatus;
}

export const TransitionStatusContext = createContext<Context | undefined>(
  undefined
);

interface Props {
  state: TransitionStatus;
  children: ReactNode;
}

export const TransitionStatusProvider = ({ children, state }: Props) => {
  const value = useMemo(
    () => ({
      state,
    }),
    [state]
  );
  return (
    <TransitionStatusContext.Provider value={value}>
      {children}
    </TransitionStatusContext.Provider>
  );
};

export const useTransitionStatusContext = () => {
  const context = useContext(TransitionStatusContext);
  if (typeof context === 'undefined') {
    throw new Error(
      'useTransitionStatusContext: Attempting to access undefined context, possibly outside of `TransitionStatusProvider`'
    );
  }
  return context;
};
